import { render, staticRenderFns } from "./EntityItemPropertiesSection.vue?vue&type=template&id=d69165d2&"
import script from "./EntityItemPropertiesSection.vue?vue&type=script&setup=true&lang=ts&"
export * from "./EntityItemPropertiesSection.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports